import type { Action } from 'state/actions';
import { patchKey, removeKey, setKey } from 'state/utils/collection';

import type { TradeCancellationsState } from './cancellations.models';
import { initialTradeCancellationsState } from './cancellations.models';

export function tradesCancellationsReducer(
  state: TradeCancellationsState = initialTradeCancellationsState,
  action: Action,
): TradeCancellationsState {
  switch (action.type) {
    case 'TRADE_CANCELLATION_WORKFLOW_INIT':
      return setKey(action.tradeId, {
        status: 'INIT' as const,
        blotterItem: action.blotterItem,
        blotterType: action.blotterType,
      });
    case 'TRADE_CANCELLATION_WORKFLOW_ABORTED':
      return removeKey(state, action.tradeId);
    case 'TRADE_CANCELLATION_WORKFLOW_COMPLETED':
      return removeKey(state, action.tradeId);
    case 'TRADE_CANCELLATION_REQUESTED':
      return patchKey(state, action.tradeId, () => ({ status: 'IN_PROGRESS' as const }));
    case 'TRADE_CANCELLED':
      return patchKey(state, action.tradeId, () => ({ status: 'SUCCESS' as const }));
    case 'TRADE_CANCELLATION_FAILED':
      return patchKey(state, action.tradeId, () => ({ status: 'FAILED' as const }));
    case 'TRADE_CANCELLATION_REJECTED':
      return patchKey(state, action.tradeId, () => ({ status: 'REJECTED' as const, error: action.error }));
    default:
      return state;
  }
}
